export default function isScrollPositionAtMenuBottom(menuRef: any) {
    const { scrollHeight, scrollTop, clientHeight } = menuRef;
    return scrollHeight - scrollTop === clientHeight;
}
